export const SET_CALLBACK_REFERRER_URL = "SET_CALLBACK_REFERRER_URL";
export const UNSET_CALLBACK_REFERRER_URL = "UNSET_CALLBACK_REFERRER_URL";
export const SET_CALLBACK_REASON = "callbackPage/SET_CALLBACK_REASON";
